<template>
  <div class="manageQuery">
    <div class="queryHeader">
      <van-nav-bar
        title="数据查询"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    
     <van-row>
        <van-tabs v-model="active">
          <!-- <van-tab title="申请信息">
             <div class="content">
              <applyInfo />
             </div>
          </van-tab>
          <van-tab title="申请次数">
            <div class="content">
               <cardPool />
            </div>
          </van-tab>
          <van-tab title="逾期未取">
             <div class="content">
              <overdue />
             </div>
          </van-tab>
          <van-tab title="存储信息">
             <div class="content">
              <plateInStock />
             </div>
          </van-tab> -->
          <div class="content">
            <van-tab v-for="item in titleList" :key="item.index" :title="item.title">
            <applyInfo v-if="item.index == '1'"/>
            <cardPool v-if="item.index == '2'"/>
            <overdue v-if="item.index == '3'"/>
            <plateInStock v-if="item.index == '4'"/>
            <history v-if="item.index == '5'"/>
          </van-tab>
          </div>
        </van-tabs>
    </van-row>
    </div>
  </div>
</template>

<script>
import {Tab,Tabs} from 'vant'
import cardPool from '@/components/query/cardPool.vue'
import applyInfo from '@/components/query/applyInfo.vue'
import overdue from '@/components/query/overdueIndex.vue'
import plateInStock from '@/components/query/plateInStock.vue'
import history from '@/components/query/history.vue'
export default {
  // mounted(){
  //   this.echartsInit()
  // },
  components:{
    cardPool,
    applyInfo,
    overdue,
    plateInStock,
    history
  },
  filters:{

  },
  data(){
    return{
     active:0,// 0申请信息查询，1身份证查询
     titleList:[
                {'index':'1','title':'申请信息'},
                {'index':'2','title':'申请次数'},
                {'index':'3','title':'逾期未取'},
                {'index':'4','title':'存储位置'},
                {'index':'5','title':'历史记录'},
            ]
    }
  },
  methods:{
    // 返回
    goBack(){
      console.log('返回管理员首页');
      this.$router.push('/manager')
    },

   
  }

}
</script>

<style lang="scss" >
.manageQuery{
  .van-nav-bar .van-icon{
    color: #0283ef;
  }
  .van-nav-bar__text{
    color: #0283ef;
  }
  .queryHeader{
    width: 100%;
    height: 8%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: #fff;
    .van-tab--active{
      color: #0283ef;
    }
    .van-tabs__line{
      background-color: #0283ef;
    }
  }
  .content{
    overflow-y: auto;//内容溢出垂直滚动
    height: calc(100vh - 110px);//内容区高度，确保占满剩余可视窗口
  }
  .van-tabs__wrap--scrollable .van-tab{
      padding: 0;
    }

}

</style>